import { Controller } from "@hotwired/stimulus";

// Bulk review actions: show toolbar when rows selected; form submits via formaction on buttons
export default class extends Controller {
  static targets = ["toolbar", "count", "selectAll"];

  updateCount() {
    const checked = this.element.querySelectorAll(".bulk-row-cb:checked");
    const n = checked.length;
    if (this.hasCountTarget) this.countTarget.textContent = n;
    if (this.hasToolbarTarget) this.toolbarTarget.classList.toggle("hidden", n === 0);
    if (this.hasSelectAllTarget) {
      const all = this.element.querySelectorAll(".bulk-row-cb");
      this.selectAllTarget.checked = n > 0 && n === all.length;
    }
  }

  toggleAll(event) {
    const checked = event.target.checked;
    this.element.querySelectorAll(".bulk-row-cb").forEach((cb) => (cb.checked = checked));
    this.updateCount();
  }
}
